// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"418f5c21","488":"ac907be8"}[chunkId] + ".chunk.js";
};